export function conditionReportPdfHref(productId) {
  if (productId == null || productId === "") return "";
  return `/pdf/${encodeURIComponent(productId)}/report`;
}
